export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_INITIALIZED = 'SET_INITIALIZED';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';